import type { InsuranceDetails, Patient } from "~/api/patients";
import {
  INSURANCE_PROVIDERS,
  MARTINS_POINT_INSURANCE_PROVIDER,
  PLAN_TYPE_PROVIDERS,
  REFERRED_BY_VALUES,
  UHC_PLAN_COVERAGE_MEDICAID,
  UHC_PLAN_COVERAGE_MEDICARE,
  VIDEO_CALL_LOCATION,
} from "~/utils";

const UHC_PLAN_COVERAGE = {
  ...UHC_PLAN_COVERAGE_MEDICAID,
  ...UHC_PLAN_COVERAGE_MEDICARE,
} as const;

export const mapProviderName = (providerName: string): string | undefined => {
  if (providerName === "martinsPoint") {
    return MARTINS_POINT_INSURANCE_PROVIDER;
  }
  return INSURANCE_PROVIDERS[providerName as keyof typeof INSURANCE_PROVIDERS];
};

export const mapPreferredOffice = (patient: Patient): string => {
  if (
    patient.visitType &&
    patient.visitType !== "Telehealth" &&
    patient.preferredOfficeVisit
  ) {
    return patient.preferredOfficeVisit;
  }
  return VIDEO_CALL_LOCATION;
};

export const mapPlanCoverage = (
  insurance: InsuranceDetails,
): string | undefined => {
  return insurance.planCoverage || undefined;
};

export const mapUhcPlan = (insurance: InsuranceDetails): string | undefined => {
  if (insurance.uhcPlan) {
    return UHC_PLAN_COVERAGE[
      insurance.uhcPlan as keyof typeof UHC_PLAN_COVERAGE
    ];
  }
  return undefined;
};

export const mapReferral = (referral: string): string | undefined => {
  return REFERRED_BY_VALUES[referral as keyof typeof REFERRED_BY_VALUES];
};

export interface MappedInsurance {
  memberId?: string;
  providerName?: string;
  otherProvider?: string;
  type?: string;
  planCoverage?: string;
  bcbsProvider?: string;
  anthemEmpirePos?: string;
  uhcPlan?: string;
  aetnaPlan?: string;
  medicalConditions?: string[];
  isOutOfNetwork?: boolean;
}

export const mapInsuranceDetails = (
  insurance: InsuranceDetails | undefined,
): MappedInsurance | undefined => {
  if (!insurance?.providerName) return undefined;

  return {
    memberId: insurance.memberId,
    providerName: mapProviderName(insurance.providerName),
    otherProvider: insurance.otherProvider || undefined,
    type: insurance.planTypeProvider
      ? PLAN_TYPE_PROVIDERS[
          insurance.planTypeProvider as keyof typeof PLAN_TYPE_PROVIDERS
        ]
      : undefined,
    planCoverage: mapPlanCoverage(insurance),
    bcbsProvider: insurance.bcbsProvider || undefined,
    anthemEmpirePos: insurance.anthemEmpirePos || undefined,
    uhcPlan: mapUhcPlan(insurance),
    aetnaPlan: insurance.aetnaPlan || undefined,
    medicalConditions: insurance.medicalConditions,
    isOutOfNetwork: insurance.isOutOfNetwork,
  };
};
